/**
 * ScandiPWA - Progressive Web App for Magento
 *
 * Copyright © Scandiweb, Inc. All rights reserved.
 * See LICENSE for license details.
 *
 * @license OSL-3.0 (Open Software License ("OSL") v. 3.0)
 * @package scandipwa/scandipwa
 * @link https://github.com/scandipwa/scandipwa
 */

import ProductListQuery from 'Query/ProductList.query';
import { LinkedProductsDispatcher as SourceLinkedProductsDispatcher } from 'SourceStore/LinkedProducts/LinkedProducts.dispatcher';
import { getIndexedProduct } from 'Util/Product';
import { getProductInStock } from 'Util/Product/Extract';

export * from 'SourceStore/LinkedProducts/LinkedProducts.dispatcher';

/** @namespace Bookland/Store/LinkedProducts/Dispatcher */
export class LinkedProductsDispatcher extends SourceLinkedProductsDispatcher {
    _processResponse(data, product_links) {
        const { products: { items } } = data;

        const indexedBySku = items.reduce((acc, item) => {
            const { sku } = item;

            if (getProductInStock(item)) {
                acc[sku] = getIndexedProduct(item);
            }

            return acc;
        }, {});

        const linkedProducts = product_links.reduce((acc, link) => {
            const { linked_product_sku, link_type } = link;

            if (indexedBySku[linked_product_sku] && acc[link_type]) {
                acc[link_type].items.push(
                    indexedBySku[linked_product_sku]
                );

                acc[link_type].total_count++;
            }

            return acc;
        }, {
            upsell: { total_count: 0, items: [] },
            related: { total_count: 0, items: [] },
            crosssell: { total_count: 0, items: [] },
            associated: { total_count: 0, items: [] },
            fbt: { total_count: 0, items: [] },
            category: { total_count: 0, items: [] }
        });

        return linkedProducts;
    }

    /**
     * Prepare LinkedProducts query
     * @return {Query} ProductList query
     * @memberof LinkedProductsDispatcher
     * @param product_links
     */
    prepareRequest(product_links) {
        const relatedSKUs = product_links.reduce((links, link) => {
            const { linked_product_sku } = link;

            return [...links, linked_product_sku];
        }, []);

        return [
            ProductListQuery.getQuery({
                args: {
                    filter: {
                        productsSkuArray: relatedSKUs
                    },
                    pageSize: 100
                },
                notRequireInfo: true
            })
        ];
    }
}

export default new LinkedProductsDispatcher();
